import { render, staticRenderFns } from "./Stages.vue?vue&type=template&id=4891a671&scoped=true&"
import script from "./Stages.vue?vue&type=script&lang=ts&"
export * from "./Stages.vue?vue&type=script&lang=ts&"
import style0 from "./Stages.vue?vue&type=style&index=0&id=4891a671&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4891a671",
  null
  
)

export default component.exports